module.exports = __webpack_public_path__ + "static/1_2-e0fe3fcff7a42377adf9f91d80798e79.jpg";